export default "__VITE_ASSET__De0uECHJ__"